const PROD_API_BASE = "https://api.karatscan.com/api/v1";

export const DEFAULT_API_BASE = import.meta.env.VITE_API_BASE || PROD_API_BASE;

const API_BASES = {
  staging: "http://127.0.0.1:8080/api/v1",
};

export const DEFAULT_TWEAKS = {
  theme: "light",
  density: "compact",
  feedLayout: "grid",
  accent: "amber",
  showAlertsRail: true,
  signedIn: false,
  brandTagline: "Gold deals, priced honestly",
};

const TEST_TWEAKS_STORAGE_KEY = "karatscan:test:tweaks";
const TEST_TWEAKS_SOURCE = "playwright";
const TEST_TWEAK_VALUES = {
  theme: new Set(["light", "dim"]),
  density: new Set(["compact", "comfortable"]),
  feedLayout: new Set(["grid", "list"]),
};

const browserSearch = () =>
  typeof window !== "undefined" && window.location ? window.location.search : "";

const browserTestTweaks = () => {
  if (typeof window === "undefined") return {};
  try {
    const storage = window.localStorage;
    if (!storage) return {};
    const raw = storage.getItem(TEST_TWEAKS_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.source !== TEST_TWEAKS_SOURCE) return {};
    return Object.fromEntries(
      Object.entries(TEST_TWEAK_VALUES)
        .map(([key, allowed]) => [key, allowed.has(parsed[key]) ? parsed[key] : undefined])
        .filter(([, value]) => value != null),
    );
  } catch {
    return {};
  }
};

export function resolveRuntimeDataConfig({
  search = browserSearch(),
  defaultApiBase = DEFAULT_API_BASE,
} = {}) {
  const params = new URLSearchParams(search);
  const custom = params.get("api");
  const env = params.get("env");
  const base = custom || (env && API_BASES[env]) || defaultApiBase;
  const dataMode = params.get("data") || "live";
  return { apiBase: base, dataMode };
}

export function resolveTweaks(overrides = {}) {
  const testTweaks = browserTestTweaks();
  return overrides && typeof overrides === "object"
    ? { ...DEFAULT_TWEAKS, ...testTweaks, ...overrides }
    : { ...DEFAULT_TWEAKS, ...testTweaks };
}

export const RUNTIME_DATA_CONFIG = resolveRuntimeDataConfig();
export const API_BASE = RUNTIME_DATA_CONFIG.apiBase;
export const DATA_MODE = RUNTIME_DATA_CONFIG.dataMode;
export const TWEAKS = resolveTweaks();
